"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailTemplateAddApi = emailTemplateAddApi;
exports.emailTemplateDeleteApi = emailTemplateDeleteApi;
exports.emailTemplateFetchApi = emailTemplateFetchApi;
exports.emailTemplateListApi = emailTemplateListApi;
exports.emailTemplateSoftDeleteApi = emailTemplateSoftDeleteApi;
exports.emailTemplateSoftDeleteRestoreApi = emailTemplateSoftDeleteRestoreApi;
exports.emailTemplateSoftDeletedListApi = emailTemplateSoftDeletedListApi;
exports.emailTemplateUpdateApi = emailTemplateUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list.
 */
function emailTemplateListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.list), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function emailTemplateFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.fetch), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function emailTemplateAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.add), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function emailTemplateUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.fetch), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function emailTemplateDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.delete), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used for sofft delete of platform admin user.
 */
function emailTemplateSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.softDelete), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used for sofft delete restore of platform admin user.
 */
function emailTemplateSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.softDeleteRestore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used for sofft deleted list.
 */
function emailTemplateSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.emailTemplateService.emailTemplate.softDeletedList), params);
}